<template>
  <div
    v-if="visible"
    :class="'fullscreen cvpreview' + className"
    :style="{ width: boxWidth || '', zIndex: `${zindex}` }"
    @contextmenu.prevent.stop="
      () => {
        return false
      }
    "
  >
    <div class="preview-title" @mousedown="domdrag($el, $event)">
      <h2 v-show="!showHighlight">附件预览</h2>
      <div v-show="showHighlight" class="cvpreview-tabs">
        <div class="cvpreview-tab" :class="{ 'cvpreview-tab-active': activeTab == 'file' }" @click="activeTab = 'file'">
          附件预览
        </div>
        <div
          class="cvpreview-tab"
          :class="{ 'cvpreview-tab-active': activeTab == 'highlight' }"
          @click="activeTab = 'highlight'"
        >
          人选亮点/风险点提示
        </div>
      </div>
      <div>
        <a v-if="!isMax" class="preview-max" href="javascript:;" title="最大化" @click="max"></a>
        <a v-else class="preview-revert" href="javascript:;" title="还原" @click="revert"></a>
        <a class="preview-close" href="javascript:;" title="关闭" @click="close"></a>
      </div>
    </div>
    <div class="preview-resizeL" @mousedown="resize($el, $event.target, true, false, false, true)"></div>
    <div class="preview-resizeT" @mousedown="resize($el, $event.target, false, true, true, false)"></div>
    <div class="preview-resizeR" @mousedown="resize($el, $event.target, false, false, false, true)"></div>
    <div class="preview-resizeB" @mousedown="resize($el, $event.target, false, false, true, false)"></div>
    <div class="preview-resizeLT" @mousedown="resize($el, $event.target, true, true, false, false)"></div>
    <div class="preview-resizeTR" @mousedown="resize($el, $event.target, false, true, false, false)"></div>
    <div class="preview-resizeBR" @mousedown="resize($el, $event.target, false, false, false, false)"></div>
    <div class="preview-resizeLB" @mousedown="resize($el, $event.target, true, false, false, false)"></div>
    <div v-if="dragLeft" class="preview-cover"></div>

    <div v-loading="loading" class="preview-content col-1" style="position:relative">
      <div
        v-if="file && (isAdmin || file.type == '推荐报告' || (isFinance && file.type == '付款通知书')) && userInservice"
        class="preview-download"
        @click="downloadFile"
      >
        下载
      </div>
      <!-- <div v-show="mask" class="embed-cover" @scroll.stop.prevent="onScroll"></div> -->
      <iframe
        v-if="isOld"
        v-show="suffix !== 'jpg' && suffix !== 'jpeg' && suffix !== 'png'"
        id="iframe"
        :src="`${previewUrl}#toolbar=0`"
        width="100%"
        height="100%"
        frameborder="no"
        border="0"
        marginwidth="0"
        marginheight="0"
        scrolling="auto"
        allowtransparency="yes"
      />
      <div
        v-show="!isOld && isWpsUrl && (!showHighlight || activeTab == 'file')"
        id="testIframe"
        :style="`height:85vh !important`"
      ></div>
      <div
        v-show="showHighlight && activeTab == 'highlight'"
        style="padding:10px 15px;line-height:1.5;height: calc(100vh - 120px);overflow: auto;"
      >
        <div>
          <i class="el-icon-warning" style="font-size:14px;margin-right:5px"></i>
          <span style="color:#e6a23c;font-size:14px">注意点X{{ risks.contents.length }}</span>
        </div>
        <div>
          <el-tag v-for="(item, k) in risks.tags" :key="k" size="mini" type="warning" style="margin:5px 3px">{{
            item
          }}</el-tag>
        </div>
        <div>
          <div v-for="(item, k) in risks.contents" :key="k">
            <i class="el-icon-s-help" style="color:#e6a23c;margin-right:5px"></i> <span>{{ item }}</span>
          </div>
        </div>
        <div style="height:10px;border-top:1px solid #ccc;margin-top:10px"></div>
        <div>
          <i class="el-icon-s-opportunity" style="font-size:14px;margin-right:5px"></i>
          <span style="color:#409eff;font-size:14px">简历亮点X{{ highlights.contents.length }}</span>
        </div>
        <div>
          <el-tag v-for="(item, k) in highlights.tags" :key="k" size="mini" style="margin:5px 3px">{{ item }}</el-tag>
        </div>
        <div>
          <div v-for="(item, k) in highlights.contents" :key="k">
            <i class="el-icon-s-help" style="color:#409eff;margin-right:5px"></i> <span>{{ item }}</span>
          </div>
        </div>
        <div style="height:10px;border-top:1px solid #ccc;margin-top:10px"></div>
        <template v-if="recommendTexts.length > 0">
          <div style="font-size:14px;margin-bottom:5px;color:#999">
            <i class="el-icon-s-order" style="font-size:14px;margin-right:5px"></i> <span>过往推荐概述：</span>
          </div>
          <div v-show="recommendTexts.length > 0" style="padding: 0 15px;font-size:14px">
            <span v-show="recommendTexts.length > 1" class="a-link" @click="nextTextIndex">
              <i class="el-icon-refresh"></i> 换一个
            </span>
            <span class="a-link" style="margin-left:20px" @click="copyText">
              <i class="el-icon-document-copy"></i> 复制
            </span>
          </div>
          <div style="white-space: pre-wrap;padding:0 15px">{{ recommendTexts[recommendTextIndex] }}</div>
          <div style="height:10px;border-top:1px solid #ccc;margin-top:10px"></div>
        </template>
        <div style="font-size:14px;margin-bottom:5px;color:#999">
          <i class="el-icon-s-order" style="font-size:14px;margin-right:5px"></i> <span>系统建议推荐概述：</span>
        </div>
        <div style="margin-bottom:5px;padding:0 15px">{{ pipeiduText || '无' }}</div>
      </div>
      <div v-viewer style="max-height: 100%; overflow-y: auto;"><img v-show="isImgUrl" :src="previewUrl" /></div>
      <template v-if="!isOld">
        <div
          v-for="i in 8"
          :key="i"
          class="alpha-water-mark-one"
          :style="{ top: (Math.ceil(i / 2) - 1) * 200 + 'px', left: i % 2 == 1 ? '20%' : '60%' }"
        >
          {{ account }}
        </div>
      </template>
    </div>

    <!-- <div class="preview-close ft-danger"><i class="el-icon-close" @click="close" /></div> -->
  </div>
</template>

<script>
// TODO: 这里的预览需要用户已登录，为了方便复制了一份PublicPreview，不需要登录，且只能预览上传到publicUploads的文件
import { download } from '../../../project/src/constant/utils'
import WPSOfficeSDK from '../../../assets/weboffice/web-office-sdk-v1.1.2.es'

let wpsOfficeInstance

export default {
  props: {
    className: { type: String, default: '' },
  },
  data() {
    return {
      file: undefined,
      previewUrl: undefined,
      visible: false,
      boxWidth: '40vw',
      loading: false,
      dragMinWidth: 250,
      dragMinHeight: 124,
      isMax: false,
      dragLeft: false,
      zindex: 1000,
      // 是否在职，在职true
      userInservice: true,
      token: '',
      isOld: false,

      showHighlight: false,
      activeTab: 'file',
      pipeiduText: '',
      highlights: { tags: [], contents: [] },
      risks: { tags: [], contents: [] },
      recommendTexts: [],
      recommendTextIndex: 0,
    }
  },
  computed: {
    suffix() {
      const previewUrl = this.previewUrl
      return (previewUrl && previewUrl.substr(previewUrl.lastIndexOf('.') + 1)) || ''
    },
    isAdmin() {
      return app.user.角色 && app.user.角色.includes('管理员')
    },
    isFinance() {
      return app.user.角色 && app.user.角色.includes('财务')
    },
    isShuju() {
      return app.user.角色 && app.user.角色.includes('数据处理')
    },
    isWpsUrl() {
      return /wps\.cn/.test(this.previewUrl)
    },
    isImgUrl() {
      return /(\.png)|(\.jpg)|(\.jpeg)/.test(this.previewUrl)
    },
    account() {
      return app.user.account
    },
  },
  mounted() {
    this.userInservice = !['离职中', '已离职'].includes(app.user.状态)
    // this.userInservice = !['离职中', '已离职'].includes(app.user.状态)
  },
  methods: {
    downloadFile() {
      if (this.file) download(this.file)
    },
    max() {
      this.$el.style.left = 0
      this.$el.style.top = '60px'
      this.$el.style.width = '100vw'
      this.$el.style.height = 'calc(100vh - 60px)'
      this.isMax = true
    },
    revert() {
      this.$el.style.left = 0
      this.$el.style.top = '60px'
      this.$el.style.width = this.boxWidth
      this.$el.style.height = 'calc(100vh - 60px)'
      this.isMax = false
    },
    close() {
      wpsOfficeInstance&&wpsOfficeInstance.destroy&&wpsOfficeInstance.destroy()
      this.$nextTick(()=>{
        this.visible = false
      })
    },
    loadFileByUrl(url) {
      this.previewUrl = url
      this.show()
    },
    async getFile(file, params = {}) {
      const { md5, fileId, _id } = file
      if (!md5 && !fileId && !_id) return
      this.loading = true
      this.file = file
      const { showHighlight, pid, rid, width } = params
      this.showHighlight = !!showHighlight
      this.boxWidth = width || '40vw'
      let fileData
      try {
        if (rid) {
          const res = await app.service('radish').getRadishPrevousRecommendText({ rid })
          this.recommendTexts = []
          this.recommendTextIndex = 0
          if (res && res.status === 'success') {
            this.recommendTexts = res.data || []
          }
        }
        if (rid && pid) {
          const rp = await app.service('radish').getRadishProject({ rid, pid })
          if (rp.status == 'success' && rp.data) {
            if (rp.data.pipeiduText) {
              this.pipeiduText = rp.data.pipeiduText
            } else {
              const pi = await app.service('radish').initRecommendText({ rid, pid })
              this.pipeiduText = pi.data.pipeiduText
            }
          }
        }
        if (this.showHighlight) {
          if (!file.data || !file.data.人才画像预测) {
            file.data = await app.service('file').analyse({ md5: file.md5, force: true, category: 'xxAnalyze' })
            fileData = file.data
          }
          this.activeTab = 'file'
          if (file.data && file.data.人选画像预测) {
            const hls = file.data.人选画像预测.highlights
            const risks = file.data.人选画像预测.risks
            if (hls) {
              this.highlights = {
                tags: hls.tags,
                contents: [...hls.project, ...hls.occupation, ...hls.education, ...hls.others],
              }
            }
            if (risks) {
              this.risks = {
                tags: risks.tags,
                contents: [...risks.occupation, ...risks.education],
              }
            }
          }
        }

        const query = md5 ? { md5 } : fileId || _id ? { _id: fileId || _id } : undefined
        const src = await window.app.service('file').buildPreview(query)
        let url = src.wpsUrl
        this.isOld = src.isOld
        if (!/wps\.cn/.test(url)) {
          url = src.wpsUrl.includes('http') ? src.wpsUrl : window.host + src.wpsUrl
        }
        if (location.origin.indexOf('https://') !== -1) {
          this.previewUrl = url.replace('http://', 'https://')
        } else if (location.origin.indexOf('http://') !== -1) {
          this.previewUrl = url.replace('https://', 'http://')
        }
        this.token = src.token
        this.show()
      } catch (error) {
        this.$message.error(`预览：${(error.response && error.response.message) || error.message}`)
        this.close()
      }
      this.loading = false
      return fileData
    },
    show() {
      // this.revert()
      this.visible = true
      this.zindex = app.root.dragindex++
      this.$nextTick(() => {
        this.revert()
      })
      if (this.isWpsUrl) {
        this.$nextTick(async () => {
          const wps = WPSOfficeSDK.config({
            mode: 'simple',
            mount: document.querySelector('#testIframe'),
            commonOptions: {
              isShowTopArea: false, // 隐藏顶部区域(头部和工具栏)
              isShowHeader: false, // 隐藏头部区域
            },
            wordOptions: {
              isShowDocMap: true,
              isBestScale: true,
            },
            pdfOptions: {
              isInSafeMode: !this.isShuju,
              isShowComment: false,
            },
            url: this.previewUrl,
          })
          wps.setToken({ token: this.token })
          await wps.ready()
          const app = wps.Application

          // 获取剪切板回调事件
          // setTimeout(() => {
          app.Sub.Clipboard_Copy = async e => {
            if (this.isShuju) {
              return
            }
            if (!this.showHighlight) {
              await navigator.clipboard.writeText('')
            }
          }
          app.Sub.ClipboardCopy = async e => {
            if (this.isShuju) {
              return
            }
            if (!this.showHighlight) {
              await navigator.clipboard.writeText('')
            }
          }
          if (app && app.ActivePDF) {
            app.ActivePDF.DocumentMap = false
          }
          wpsOfficeInstance = wps
          // this.$nextTick(async () => {
          //   if (app && app.ActivePDF) {
          //     app.ActivePDF.DocumentMap = false
          //     // 确保网速不好加载慢时，缩略图也能被再次关闭
          //     setTimeout(() => {
          //       if (app && app.ActivePDF) {
          //         app.ActivePDF.DocumentMap = false
          //       }
          //     }, 1500)
          //   }
          // })
        })
        // }, 1000)
      }
    },
    domdrag($el, event) {
      let startX, startY, clientX, clientY
      let isDrag = false
      event.preventDefault()
      // $el.style.zIndex = app.root.dragindex++
      startX = $el.offsetLeft
      startY = $el.offsetTop
      clientX = event.clientX
      clientY = event.clientY
      isDrag = true
      document.addEventListener('mousemove', e => {
        if (isDrag) {
          e.preventDefault()
          $el.style.left = `${e.clientX - clientX + startX}px`
          $el.style.top = `${e.clientY - clientY + startY}px`
        }
      })
      document.addEventListener('mouseup', e => {
        isDrag = false
      })
    },
    resize(oParent, handle, isLeft, isTop, lockX, lockY) {
      const { dragMinWidth, dragMinHeight, $el } = this
      const showCover = val => (this.dragLeft = val)
      handle.onmousedown = e => {
        showCover(true)
        const event = e || window.event
        const disX = event.clientX - handle.offsetLeft
        const disY = event.clientY - handle.offsetTop
        const iParentTop = oParent.offsetTop
        const iParentLeft = oParent.offsetLeft
        const iParentWidth = oParent.offsetWidth
        const iParentHeight = oParent.offsetHeight

        const iframe = $el.querySelector('#iframe')
        let iframeDocument = iframe.contentDocument

        if (iframeDocument) {
          iframeDocument.onmousemove = mouseMove
          iframeDocument.onmouseup = mouseUp
        } else {
          iframe.onload = function() {
            iframeDocument = iframe.contentDocument
            iframeDocument.onmousemove = mouseMove
            iframeDocument.onmouseup = mouseUp
          }
        }

        document.onmousemove = mouseMove
        document.onmouseup = mouseUp

        function mouseUp() {
          document.onmousemove = null
          document.onmouseup = null
          iframeDocument && (iframeDocument.onmousemove = null)
          iframeDocument && (iframeDocument.onmouseup = null)
          showCover(false)
        }
        function mouseMove(e) {
          const event = e || window.event
          const iL = event.clientX - disX
          const iT = event.clientY - disY
          const maxW = document.documentElement.clientWidth - oParent.offsetLeft - 2
          const maxH = document.documentElement.clientHeight - oParent.offsetTop - 2
          let iW = isLeft ? iParentWidth - iL : handle.offsetWidth + iL
          let iH = isTop ? iParentHeight - iT : handle.offsetHeight + iT
          const newTop = iParentTop + iT

          isLeft && iW >= dragMinWidth && (oParent.style.left = `${iParentLeft + iL}px`)
          iW < dragMinWidth && (iW = dragMinWidth)
          iW > maxW && (iW = maxW)
          lockX || (oParent.style.width = `${iW}px`)
          isTop && iH >= dragMinHeight && (oParent.style.top = `${newTop < 41 ? 41 : newTop}px`)
          iH < dragMinHeight && (iH = dragMinHeight)
          iH > maxH && (iH = maxH)
          lockY || (oParent.style.height = `${iH}px`)
          return false
        }

        return false
      }
    },
    nextTextIndex() {
      if (this.recommendTextIndex == this.recommendTexts.length - 1) {
        this.recommendTextIndex = 0
      } else {
        this.recommendTextIndex++
      }
    },
    copyText() {
      if (this.recommendTexts[this.recommendTextIndex]) {
        const oTextarea = document.createElement('textarea')
        oTextarea.value = this.recommendTexts[this.recommendTextIndex]
        document.body.appendChild(oTextarea)
        oTextarea.select()
        document.execCommand('Copy')
        document.body.removeChild(oTextarea)
        this.$message.success('复制成功')
      }
    },
  },
}
</script>

<style src="../../statics/css/cvpreview.css"></style>
